import type { TranslationKeys } from './en'

const de: TranslationKeys = {
    loading: 'Laden...',
    redirectingToLogin: 'Weiterleitung zur Anmeldung...',
    callEndpointAgain: 'Endpoint erneut aufrufen',
    language: 'Sprache',
    user: 'Benutzer',
    message: 'Nachricht',
    error: 'Ein Fehler ist aufgetreten',
    logout: 'Abmelden',
    navHome: 'Startseite',
    navSettings: 'Einstellungen',
    navTrolleys: 'Wagen',
    devicesTitle: 'Geräte',
    deviceViewInventory: 'Inventar anzeigen',
    inventoryTitle: 'Inventar',
    kpiToolsPresent: 'Werkzeuge gesamt',
    kpiToolsRemoved: 'Werkzeuge entnommen',
    kpiFoamsMonitored: 'Anzahl Schäume',
    kpiIsOnline: 'Status',
    drawerLabel: 'Schublade {{number}}',
    drawerComplete: 'vollständig',
    drawerIncomplete: 'unvollständig',
    foamSingle: 'Einzel',
    foamDouble: 'Doppel',
    toolsWord: 'Werkzeuge',
    backToInventory: 'Zurück zum Inventar',
    toolPresent: 'eingelegt',
    toolAbsent: 'entnommen',
    twinTitle: 'Digitaler Zwilling',
    twinAdminsOnly: 'Diese Ansicht ist nur für Administratoren verfügbar.',
    twinSelectNode: 'Wählen Sie einen Knoten, um Details zu sehen.',
    twinCartLabel: 'Werkstattwagen {{id}}',
    twinIpc: 'Industrie-PC',
    twinBattery: 'Akku',
    twinBoardLabel: 'Platine {{id}}',
    twinStatusUserTest: 'Benutzertest',
    twinDetailTrolley: 'Wagen-ID',
    twinDetailPrototype: 'Prototyp',
    twinDetailDrawers: 'Schubladen',
    twinDetailFoams: 'Schäume',
    twinDetailTools: 'Werkzeuge',
    twinDetailStatus: 'Status',
    twinDetailSerial: 'Seriennummer',
    twinDetailOs: 'Betriebssystem',
    twinDetailController: 'Controller-App',
    twinDetailFirmware: 'Firmware',
    twinDetailCharge: 'Ladezustand',
    twinDetailCycles: 'Ladezyklen',
    twinDetailPosition: 'Position',
    twinDetailBoards: 'Elektronikeinheiten',
    twinDetailDrawer: 'Schublade',
    twinDetailBoardId: 'Platinen-ID',
    twinDetailMcu: 'Mikrocontroller',
    twinDetailType: 'Typ',
    twinDetailMlModels: 'ML-Modelle',
    twinDetailId: 'Werkzeug-ID',
    navFoams: 'Schäume',
    foamsTitle: 'Schaum-Bibliothek',
    foamsNew: 'Neuer Schaum',
    foamsEmpty: 'Noch keine Schäume. Legen Sie einen an, um zu starten.',
    foamsAdminsOnly: 'Diese Ansicht ist nur für Administratoren verfügbar.',
    foamImage: 'Bild',
    foamName: 'Schaumname',
    foamSize: 'Größe',
    foamToolsHeading: 'Werkzeuge',
    foamActions: 'Aktionen',
    foamEdit: 'Bearbeiten',
    foamDelete: 'Löschen',
    foamEditTitle: 'Schaum bearbeiten',
    foamUploadImage: 'Bild hochladen',
    foamPlaceHint:
        'Klicken Sie auf das Bild, um eine Werkzeugmarkierung zu setzen, oder ziehen Sie einen Punkt, um ihn zu verschieben.',
    foamNoImage: 'Laden Sie ein Bild hoch, um Werkzeuge zu platzieren.',
    foamToolNameDe: 'Name (DE)',
    foamToolNameEn: 'Name (EN)',
    foamCoordX: 'X',
    foamCoordY: 'Y',
    foamRemoveTool: 'Werkzeug entfernen',
    foamSave: 'Schaum speichern',
    foamCancel: 'Abbrechen',
    foamSaved: 'Schaum gespeichert',
    foamDeleted: 'Schaum gelöscht',
    foamDeleteTitle: 'Schaum löschen',
    foamDeleteMessage: 'Dadurch werden der Schaum und seine Werkzeuge dauerhaft entfernt.',
    foamValidationName: 'Ein Schaumname ist erforderlich.',
    foamValidationImage: 'Ein Bild ist erforderlich.',
    foamModelsTitle: 'Modelldateien',
    foamModelsEmpty: 'Noch keine Modelldateien. Laden Sie einen Satz hoch, um die erste Revision zu veröffentlichen.',
    foamModelsRevision: 'Revision {{number}}',
    foamModelsLatest: 'aktuell',
    foamModelsFileName: 'Datei',
    foamModelsFileKind: 'Typ',
    foamModelsFileSize: 'Größe',
    foamModelsUpload: 'Dateien hinzufügen',
    foamModelsUploadHint: 'JSON-Dateien hierher ziehen oder „Dateien hinzufügen“ verwenden.',
    foamModelsNote: 'Was hat sich geändert? (optional)',
    foamModelsPublish: 'Revision veröffentlichen',
    foamModelsPublished: 'Revision {{number}} veröffentlicht.',
    foamModelsSelected: '{{count}} Datei(en) bereit zur Veröffentlichung',
    foamModelsClear: 'Leeren',
    foamModelsDownload: 'Herunterladen',
    foamModelsRemove: 'Entfernen',
    foamModelsRemoveTitle: 'Datei entfernen?',
    foamModelsRemoveMessage: 'Dadurch wird eine neue Revision ohne „{{name}}“ veröffentlicht. Frühere Revisionen behalten die Datei.',
    foamModelsHistoryHint: 'Revisionen sind unveränderlich — Wagen im Feld behalten die heruntergeladenen Dateien.',
    foamModelsReadOnly: 'Sie sehen eine ältere Revision. Wechseln Sie zur aktuellen, um Änderungen vorzunehmen.',
    foamModelsSaveFirst: 'Speichern Sie den Schaum, bevor Sie Modelldateien hinzufügen.',
    foamModelsFileCount: '{{files}} Dateien · {{size}}',
    foamValidationTools:
        'Platzieren Sie mindestens ein Werkzeug und geben Sie ihm einen deutschen Namen.',
    foamImportAction: 'Aus JSON importieren',
    foamImportTitle: 'Schaum aus JSON importieren',
    foamImportJsonLabel: 'Schaum-JSON wählen',
    foamImportImageLabel: 'Bild wählen',
    foamImportSummary: '{{count}} Werkzeuge erkannt',
    foamImportUnitLabel: 'Koordinateneinheit',
    foamImportUnitAuto: 'Automatisch erkennen',
    foamImportUnitFraction: 'Anteile (0–1)',
    foamImportUnitPixel: 'Pixel',
    foamImportDetectedUnit: 'Erkannt: {{unit}}',
    foamImportErrorJson: 'Diese Datei ist keine gültige Schaum-JSON.',
    foamImportErrorNoTools: 'Die Schaum-JSON enthält keine Werkzeuge.',
    foamImportErrorImage: 'Das Bild konnte nicht gelesen werden.',
    foamImportContinue: 'Weiter',
    settingsTitle: 'Profileinstellungen',
    settingsDisplayName: 'Anzeigename',
    settingsEmail: 'E-Mail',
    settingsLanguage: 'Sprache',
    settingsSave: 'Änderungen speichern',
    settingsSaved: 'Erfolgreich gespeichert',
    notFoundTitle: 'Seite nicht gefunden',
    notFoundMessage: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    notFoundBack: 'Zurück zur Startseite',
    validationDisplayNameMin: 'Anzeigename muss mindestens 2 Zeichen lang sein',
    validationEmailInvalid: 'Muss eine gültige E-Mail-Adresse sein',
    authErrorTitle: 'Authentifizierungsdienst nicht verfügbar',
    trolleysTitle: 'Werkstattwagen',
    trolleysNew: 'Neuer Wagen',
    trolleysEmpty: 'Noch keine Wagen. Legen Sie einen an, um zu starten.',
    trolleysAdminsOnly: 'Diese Ansicht ist nur für Administratoren verfügbar.',
    trolleyNotFound: 'Wagen nicht gefunden.',
    trolleyColId: 'ID',
    trolleyColName: 'Name',
    trolleyColDevice: 'Gerät',
    trolleyColDrawers: 'Schubladen',
    trolleyColFoams: 'Schäume',
    trolleyColUser: 'Zugewiesener Benutzer',
    trolleyColActions: 'Aktionen',
    trolleyColIsOnline: 'Online',
    trolleyEdit: 'Bearbeiten',
    trolleyDelete: 'Löschen',
    trolleyDeleteTitle: 'Wagen löschen',
    trolleyDeleteMessage: 'Dadurch werden der Wagen und seine Schubladenzuordnungen dauerhaft entfernt.',
    trolleyDeleted: 'Wagen gelöscht',
    trolleyCreated: 'Wagen erstellt',
    trolleySaved: 'Wagen gespeichert',
    trolleyWizardCreateTitle: 'Neuer Wagen',
    trolleyWizardEditTitle: 'Wagen bearbeiten',
    trolleyStepBasics: 'Grunddaten',
    trolleyStepDrawers: 'Schubladen',
    trolleyStepReview: 'Überprüfen',
    trolleyFieldId: 'Wagen-ID',
    trolleyFieldName: 'Name',
    trolleyFieldDevice: 'Geräte-ID',
    trolleyFieldUser: 'Zugewiesener Benutzer',
    trolleyFieldDrawerCount: 'Anzahl Schubladen',
    trolleyNext: 'Weiter',
    trolleyBack: 'Zurück',
    trolleyCreate: 'Wagen erstellen',
    trolleySave: 'Änderungen speichern',
    trolleyCancel: 'Abbrechen',
    trolleyAddFoam: 'Schaum hinzufügen',
    trolleyRemoveFoam: '{{name}} entfernen',
    trolleyNoLibraryFoams: 'Noch keine Schäume in der Bibliothek. Legen Sie zuerst unter Schäume einen an.',
    trolleyNoAssignments: 'Keine Schäume zugeordnet.',
    trolleyTabInventory: 'Inventar',
    trolleyTabTwin: 'Digitaler Zwilling',
    trolleyTabShell: 'Shell',
    trolleyFieldSshHost: 'Shell-Adresse (optional)',
    trolleyFieldSshHostHint: 'WireGuard-IP oder Hostname. Leer lassen, um den Fernzugriff für diesen Wagen zu deaktivieren.',
    trolleyValidationSshHost: 'Nur Buchstaben, Ziffern und . _ : - sind erlaubt.',
    shellAdminsOnly: 'Diese Ansicht ist nur für Administratoren verfügbar.',
    shellNoAddress: 'Für diesen Wagen ist keine Shell-Adresse hinterlegt. Tragen Sie eine in den Wagen-Einstellungen ein, um Fernzugriff zu ermöglichen.',
    shellConnect: 'Verbinden',
    shellDisconnect: 'Trennen',
    shellStatus_idle: 'Nicht verbunden',
    shellStatus_connecting: 'Verbinde…',
    shellStatus_connected: 'Verbunden',
    shellStatus_closed: 'Sitzung beendet',
    shellStatus_error: 'Verbindung fehlgeschlagen',
    trolleyDetailDevice: 'Gerät',
    trolleyDetailUser: 'Zugewiesener Benutzer',
    trolleyUnnamed: 'Unbenannter Wagen',
    trolleyMissingConfig: 'Konfiguration fehlt',
    trolleyNeedsConfigTitle: 'Dieser Wagen muss konfiguriert werden',
    trolleyNeedsConfigBody:
        'Das Gerät hat sich selbst registriert, hat aber noch keine Konfiguration. Vergeben Sie Name, Benutzer und Schubladen-Schäume, um die Einrichtung abzuschließen.',
    trolleyValidationId: 'Eine Wagen-ID ist erforderlich.',
    trolleyValidationName: 'Ein Name ist erforderlich.',
    trolleyValidationDevice: 'Eine Geräte-ID ist erforderlich.',
    trolleyValidationUser: 'Ein zugewiesener Benutzer ist erforderlich.',
    trolleyValidationDrawerCount: 'Die Anzahl der Schubladen muss mindestens 1 betragen.',
    trolleyDrawerSlots: '{{used}} / {{max}} Slots belegt',
    trolleyDrawerFull: 'Schublade ist voll',
    trolleyNoFittingFoams: 'Kein Platz mehr für weitere Schäume',
    trolleyBoardLabel: "Board {{number}}",
    trolleyBoardTooltip: "Board {{number}} (Serial: {{usb}})",
    trolleyDoubleAnchor: "Boards {{first}}–{{second}}",
    trolleyFoamDouble: "Doppel",
    trolleyNoReportedHardware: "Trolley hat noch keine Hardware gemeldet — bitte warten bis das Gerät sich registriert.",
    add: "Hinzufügen",
    cancel: "Abbrechen",
    navTemplates: 'Vorlagen',
    templatesTitle: 'Konfigurationsvorlagen',
    templatesEmpty: 'Noch keine Vorlagen. Speichern Sie eine aus einem Wagen, um zu starten.',
    templateSaveAction: 'Als Vorlage speichern',
    templateApplyAction: 'Vorlage anwenden',
    templateExportAction: 'Exportieren',
    templateImportAction: 'Importieren',
    templateSaveTitle: 'Konfiguration als Vorlage speichern',
    templateApplyTitle: 'Vorlage anwenden',
    templateApplyLabel: 'Vorlage',
    templateNameLabel: 'Vorlagenname',
    templateNoneForDrawerCount:
        'Keine Vorlagen passen zu dieser Schubladenanzahl ({{drawers}}). Nur Vorlagen mit passender Schubladenanzahl können angewendet werden.',
    templateSaved: 'Vorlage gespeichert',
    templateApplied: 'Vorlage angewendet',
    templateImported: 'Vorlage importiert',
    templateDeleted: 'Vorlage gelöscht',
    templateDeleteTitle: 'Vorlage löschen',
    templateDeleteMessage: 'Dadurch wird die Vorlage dauerhaft entfernt.',
    templateImportUnresolved:
        'Importiert, aber einige Schäume wurden nicht gefunden und übersprungen: {{names}}',
    templateImportInvalid: 'Diese Datei ist keine gültige Vorlage.',
}

export default de
